import React, { useEffect, useState } from "react";
import classNames from "classnames";

import {
  paymentMethodText,
  paymentStatusColor,
  paymentTypeColor,
  paymentAddType,
  paymentTypeBill,
  paymentStatusText,
  paymentTypeBillColor,
} from "_common/constants/statusType";
import moment from "moment";
import { formatNumber } from "_common/utils/formatValue";
import i18next from "i18next";
import NoData from "_common/component/NoData";

export default function ListData({ data }) {
  if (!data?.data?.length) return <NoData />;

  return (
    <div className="flex flex-col gap-4 bg-[#000000]">
      {data?.data?.map((item) => (
        <div
          key={`item-${item?.toString()}`}
          className="p-4 bg-[#1c1c1e] rounded"
          style={{
            boxShadow:
              "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;",
          }}
        >
          <div className="flex justify-between border-b border-b-[#FFFFFF1A] pb-2 mb-4">
            <div className=" w-full flex flex-col gap-1 text-[#9ca3af]">
              <div className="flex items-center gap-2">
                <span className="text-[#FFFF] text-[20px]">
                  {i18next.t(item?.type)}
                </span>
                <div
                  className={classNames(
                    "w-fit text-[12px] px-2 py-[2px] rounded",
                    paymentTypeBillColor[item?.type]
                  )}
                >
                  {i18next.t(paymentTypeBill[item?.type])}
                </div>
              </div>
              <div className="flex w-full items-center justify-between">
                <span className="text-xs text-[#888]">{item?.id}</span>
                <span className="text-xs text-[#888]">
                  {moment(item?.created_at).format("YYYY-MM-DD HH:mm")}
                </span>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 mt-4">
            <div className="flex justify-between text-base text-white">
              <span className="text-[14px] text-[#888]">
                {i18next.t("money_amount")}
              </span>
              <span className="text-[13px] text-white">
                {formatNumber(item.amount)} USDT
              </span>
            </div>
            <div className="flex justify-between text-base text-white">
              <span className="text-[14px] text-[#888]">
                {i18next.t("fee")}
              </span>
              <span className="text-[13px] text-white">
                {formatNumber(item.fee)} USDT
              </span>
            </div>
            <div className="flex justify-between text-base text-white">
              <span className="text-[14px] text-[#a3a3a3]">
                {i18next.t("status")}
              </span>
              <span
                className={classNames(
                  "text-[16px] ",
                  paymentStatusColor[item?.status]
                )}
              >
                {i18next.t(paymentStatusText[item?.status])}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
